import React, { FC, useEffect, useState } from "react";
import { Select } from "antd";
import { TimePicker } from "antd";

const { Option } = Select;

const moment = require("moment");
const TimeInput = (props) => {
  const { beginLimit, value, onChange, name, disabled } = props;
  const [selectOptions, setSelectOptions] = useState([]);
  const [defaultValue, setDefaultValue] = useState();

  const isEarlierThanEndLimit = (timeValue, endLimit, lastValue) => {
    let timeValueIsEarlier =
      moment(timeValue, "h:mmA").diff(moment(endLimit, "h:mmA")) < 0;
    let timeValueIsLaterThanLastValue =
      lastValue === undefined
        ? true
        : moment(lastValue, "h:mmA").diff(moment(timeValue, "h:mmA")) < 0;
    return timeValueIsEarlier && timeValueIsLaterThanLastValue;
  };

  const setHours = (dt, h) => {
    var s = /(\d+):(\d+)(.+)/.exec(h);
    dt.setHours(
      s[3] === "PM"
        ? 12 + parseInt(s[1], 10)
        : parseInt(s[1] === "12" ? "00" : s[1], 10)
    );
    dt.setMinutes(parseInt(s[2], 10));
    return dt;
  };

  useEffect(() => {
    // let timeValue = beginLimit || "12:00AM";
    // let lastValue;
    // let endLimit = props.endLimit || "11:59PM";
    // let step = props.step || 15;
    // let options = [];
    // // options.push(<option key={timeValue} value={timeValue}>{timeValue}</option>);
    // while ( isEarlierThanEndLimit(timeValue, endLimit, lastValue) ) {
    //         lastValue = timeValue;
    //         timeValue = moment(timeValue, 'h:mmA').add(step, 'minutes').format('h:mmA');
    //         options.push(timeValue);
    //     }
    // setSelectOptions(options);
  }, []);

  useEffect(() => {
    if (value) {
      const time = moment(
        `${moment(new Date())?.format("MM/DD/YYYY")} ${value}`,
        "MM/DD/YYYY HH:mm"
      );
      // console.log('test', value, time.format('h:mmA'));
      // setDefaultValue(time.format('h:mmA'));
      setDefaultValue(time);
    }
    else{
        setDefaultValue(undefined);
    }
  }, [value]);

  return (
    // <Select className="w-full" placeholder={name} value={defaultValue} disabled={disabled} onChange={(value)=>{
    //     let date = setHours(new Date(), value)
    //     onChange(moment(date)?.format("MM/DD/YYYY HH:mm:ss"))
    // }}>
    //       {selectOptions.map((option, idx: number) => (
    //         <Option key={option}>{option}</Option>
    //       ))}
    // </Select>

    <TimePicker
      format={"HH:mm"}
      value={defaultValue}
      disabled={disabled}
      onChange={(date) => {
        if (date) {
          onChange(moment(date)?.format("MM/DD/YYYY HH:mm"));
        } else {
          onChange(undefined);
        }
      }}
    />
  );
};

export default TimeInput;
